export type Route = "anteroom" | "learn";

export function parseRoute(): Route {
  const hash = window.location.hash.replace(/^#\/?/, "").toLowerCase();
  // Default into the curriculum — no second ENTER gate
  if (hash === "" || hash === "learn" || hash.startsWith("learn/")) return "learn";
  if (hash === "anteroom" || hash === "intro") return "anteroom";
  return "learn";
}

export function navigate(route: Route) {
  const next = route === "anteroom" ? "#/anteroom" : "#/learn";
  if (window.location.hash !== next) {
    window.location.hash = next;
  } else {
    window.dispatchEvent(new HashChangeEvent("hashchange"));
  }
}

export function onRouteChange(cb: (route: Route) => void): () => void {
  const handler = () => cb(parseRoute());
  window.addEventListener("hashchange", handler);
  handler();
  return () => window.removeEventListener("hashchange", handler);
}
